import CloseBtn from './CloseBtn'
export default CloseBtn